import { useEffect, useState } from "react";

export function useImageLoader(urls: string[]) {
    const [imageLoadCount, setImageLoadCount] = useState(0);
    const [imageUrls, setImageUrls] = useState<string[]>();

    useEffect(() => {
        setImageLoadCount(0);
        setImageUrls(urls);
    }, [urls]);

    useEffect(() => {
        if (!imageUrls) return;
        imageUrls.forEach((url) => {
            const image = new Image();
            image.src = url;
            image.onload = () => {
                setImageLoadCount((count) => count + 1);
            };
            image.onerror = () => {
                setImageLoadCount((count) => count + 1);
            };
        });
    }, [imageUrls]);

    const loaded = imageLoadCount === imageUrls?.length;

    return loaded;
}
